export const activityData = {
  introduction: [
    {
      question: '',
      subtitle: '',
      image: '//d2bsj3sc0hks5v.cloudfront.net/icare/images/module1/img-0v2.png',
      answers: [
        { index: 0, answer: 'Slogan' },
        { index: 1, answer: 'It\'s our promise to our guests' },
        { index: 2, answer: 'Tagline' },
        { index: 3, answer: 'A memorable experience each and every time they visit LAX' },
        { index: 4, answer: 'Jingle' }
      ],
      correct: [
        { index: 1, answer: 'It\'s our promise to our guests'}
      ],
      wrongText: 'Nice try, but not quite.',
      continueText: 'You\'re LAXceptional'
    },
      {
      question: '',
      subtitle: '',
      image: '//d2bsj3sc0hks5v.cloudfront.net/icare/images/module1/IconsArtboard+4-100.jpg',
      answers: [
        {index: 0, answer: 'Hospitality mindset'},
        {index: 1, answer: 'Discourteous employees'},
        {index: 2, answer: 'The word guest being used vs. customer'},
        {index: 3, answer: 'Unclean facility'},
        {index: 4, answer: 'Long lines'}
      ],
      correct: [
        {index: 0, answer: 'Hospitality mindset'},
        {index: 2, answer: 'The word guest being used vs. customer'},
      ],
      wrongText: "Not quite the experience we want.",
      continueText: 'You\'re a rockstar!'
    }, {
      question: '',
      subtitle: '',
      image: '//d2bsj3sc0hks5v.cloudfront.net/icare/images/module1/IconsArtboard+5-100.jpg',
      answers: [
        { index: 0, answer: 'Intelligent, Careful, Awesome, Responsible, Enlightened' },
        { index: 1, answer: 'Informative, Courteous, Approachable, Responsive, Efficient & Effective' }
      ],
      correct: [
        { index: 1, answer: 'Informative, Courteous, Approachable, Responsive, Efficient & Effective' }
      ],
      wrongText: "You got this.",
      continueText: 'Yes, you care!'
    }, {
      image: '//d2bsj3sc0hks5v.cloudfront.net/icare/images/module1/IconsArtboard+28-100.jpg',
    }
  ],
  informative: [
    {
      question: "",
      subtitle: '',
      image: '//d2bsj3sc0hks5v.cloudfront.net/icare/images/module2/IconsArtboard+6-100.jpg',
      answers: [
        { index: 0, answer: 'How to get from the airport to downtown LA'},
        {index: 1, answer: 'Location of the restrooms'},
        {index: 2, answer: 'Cost of transportation'}
      ],
      correct: [
        {index: 0, answer: 'How to get from the airport to downtown LA'},
        {index: 2, answer: 'Cost of transportation'}
      ],
      wrongText: "You're close!",
      continueText: 'Right on, you\'re a great listener!'
    },
    {
      question: '',
      subtitle: '',
      image: '//d2bsj3sc0hks5v.cloudfront.net/icare/images/module2/IconsArtboard+7-100.jpg',
      answers: [
        {index: 0, answer: 'Excitement!'},
        {index: 1, answer: 'Frustration.'}
      ],
      correct: [
        {index: 0, answer: 'Excitement!'}
      ],
      wrongText: 'Not quite right.',
      continueText: 'Nailed it! They just arrived from NY and they are excited to explore LA!'
    }, {
      question: '',
      subtitle: '',
      image: '//d2bsj3sc0hks5v.cloudfront.net/icare/images/module2/IconsArtboard+8-100.jpg',
      answers: [
        {index: 0, answer: 'Patient & understanding'},
        {index: 1, answer: 'Didn\'t know the answer'},
        {index: 2, answer: 'Shared the bus schedule'},
        {index: 3, answer: 'Explained the bus fee'},
      ],
      correct: [
        {index: 0, answer: 'Patient & understanding'},
        {index: 2, answer: 'Shared the bus schedule'},
        {index: 3, answer: 'Explained the bus fee'},
      ],
      wrongText: 'Try again, you got this!',
      continueText: 'Gold Star! Britt has heard this question 100 times yet he was patient, knowledgeable, and friendly.'
    }
  ],
  courteous: [
    {
      question: '',
      subtitle: '',
      image: '//d2bsj3sc0hks5v.cloudfront.net/icare/images/module3/IconsArtboard+9-100.jpg',
      answers: [
        {index: 0, answer: 'He was very upset that he lost a good cup of coffee that he needed desperately'},
        {index: 1, answer: 'He was in a hurry to get to his gate'},
        {index: 2, answer: 'He was frustrated that he didn\'t know where Gate 38 was located in the airport'}
      ],
      correct: [
        {index: 0, answer: 'He was very upset that he lost a good cup of coffee that he needed desperately'},
        {index: 2, answer: 'He was frustrated that he didn\'t know where Gate 38 was located in the airport'}
      ],
      wrongText: "Almost, select two emotions he was feeling.",
      continueText: 'Gold star for emotional intelligence!'
    },
    {
      question: '',
      subtitle: ' ',
      image: '//d2bsj3sc0hks5v.cloudfront.net/icare/images/module3/IconsArtboard+12-100.jpg',
      answers: [
        {index: 0, answer: 'He needed comfort to know it was ok. She would take care of the spill.'},
        {index: 1, answer: 'He needed a new cup of coffee.'},
        {index:2, answer: 'He needed directions to his gate so he would not miss his flight.'}
      ],
      correct: [
        {index: 0, answer: 'He needed comfort to know it was ok. She would take care of the spill.'},
        {index:2, answer: 'He needed directions to his gate so he would not miss his flight.'}
      ],
      wrongText: 'Good effort.',
      continueText: 'You rock!'
    }, {
      question: '',
      subtitle: '',
      image: '//d2bsj3sc0hks5v.cloudfront.net/icare/images/module3/IconsArtboard+13-100.jpg',
      answers: [
        {index: 0, answer: 'Assuring the guest not to worry, and she would clean up the spill'},
        {index: 1, answer: 'Staying focused on sweeping'},
        {index: 2, answer: 'Directing the guest to his gate'},
        {index: 3, answer: 'Placing hazard sign near the spill to prevent safety risks to other guests'},
        {index: 4, answer: 'Handing the guest paper towels to clean up the spill himself'},
        {index: 5, answer: 'Being courteous and exuding warmth as she said, "You\'re welcome"'}
      ],
      correct: [
        {index: 0, answer: 'Assuring the guest not to worry, and she would clean up the spill'},
        {index: 2, answer: 'Directing the guest to his gate'},
        {index: 3, answer: 'Placing hazard sign near the spill to prevent safety risks to other guests'},
        {index: 5, answer: 'Being courteous and exuding warmth as she said, "You\'re welcome'}
      ],
      wrongText: 'It\'s ok!',
      continueText: 'You\'re a Rock Star, she was friendly, sincere, & respectful and patient in her words and attentive to his needs'
    }, {
      question: '',
      subtitle: '',
      image: '//d2bsj3sc0hks5v.cloudfront.net/icare/images/module3/IconsArtboard+14-100.jpg',
      answers: [
        {index: 0, answer: 'Yes!'},
        {index: 1, answer: 'No.'},
      ],
      correct: [
        {index: 1, answer: 'No.'},
      ],
      wrongText: 'You got this, try again as pointing can be perceived as discourteous.',
      continueText: 'When guiding a guest, use an open hand with two or three fingers outright to direct the guest.'
    }
  ],
  approachable: [
    {
      question: '',
      subtitle: ' ',
      image: '//d2bsj3sc0hks5v.cloudfront.net/icare/images/module4/IconsArtboard+15-100.jpg',
      answers: [
        {index: 0, answer: 'Confusion.'},
        {index: 1, answer: 'Excitement!'},
      ],
      correct: [
        {index: 0, answer: 'Confusion.'},
      ],
      wrongText: 'Sorry',
      continueText: 'Nailed it!'
    }, {
      question: '',
      subtitle: '',
      image: '//d2bsj3sc0hks5v.cloudfront.net/icare/images/module4/IconsArtboard+16-100.jpg',
      answers: [
        {index: 0, answer: 'She needed to get something to eat quickly'},
        {index: 1, answer: 'She needed to check her baggage quickly to make her 10:55 flight'},
      ],
      correct: [
        {index: 1, answer: 'She needed to check her baggage quickly to make her 10:55 flight'},
      ],
      wrongText: 'Nice try...',
      continueText: 'EPIC!'
    }, {
      question: '',
      subtitle: '',
      image: '//d2bsj3sc0hks5v.cloudfront.net/icare/images/module4/IconsArtboard+17-100.jpg',
      answers: [
        {index: 0, answer: 'Came out from behind the counter & quickly checked her bag'},
        {index: 1, answer: 'Directed her inside as it was too late to check her luggage'},
        {index: 2, answer: 'Called her by name; Miss Calloway'},
        {index: 3, answer: 'He was very busy checking other guests into their flight'},
      ],
      correct: [
        {index: 0, answer: 'Came out from behind the counter & quickly checked her bag'},
        {index: 2, answer: 'Called her by name; Miss Calloway'},
      ],
      wrongText: 'You got this.',
      continueText: 'Kenji was accessible, visible, and professional and had a "Can Do" attitude!'
    }
  ],
  responsive: [
    {
      question: '',
      subtitle: '',
      image: '//d2bsj3sc0hks5v.cloudfront.net/icare/images/module5/IconsArtboard+18-100v2.jpg',
      answers: [
        {index: 0, answer: 'Ride home from Officer Price.'},
        {index: 1, answer: 'Help with her phone to call her friend to pick her up at the airport.'},
      ],
      correct: [
        {index: 1, answer: 'Help with her phone to call her friend to pick her up at the airport.'},
      ],
      wrongText: "Really??",
      continueText: 'Crushing it!!'
    },
    {
      question: '',
      subtitle: ' ',
      image: '//d2bsj3sc0hks5v.cloudfront.net/icare/images/module5/IconsArtboard+19-100.jpg',
      answers: [
        {index: 0, answer: 'Happy & excited to be home'},
        {index: 1, answer: 'Frazzled, distraught, upset'},
      ],
      correct: [
        {index: 1, answer: 'Frazzled, distraught, upset'},
      ],
      wrongText: 'You got this.',
      continueText: 'You rock!!'
    }, {
      question: '',
      subtitle: '',
      image: '//d2bsj3sc0hks5v.cloudfront.net/icare/images/module5/IconsArtboard+20-100.jpg',
      answers: [
        {index: 0, answer: 'He acted with a sense of urgency'},
        {index: 1, answer: 'He walked past the guest as he was on his way to another area'},
        {index: 2, answer: 'He listened to what the guest needed from him'},
        {index: 3, answer: '"I don\'t know about iPhones, I have an Android."'},
      ],
      correct: [
        {index: 0, answer: 'He acted with a sense of urgency'},
        {index: 2, answer: 'He listened to what the guest needed from him'},
      ],
      wrongText: 'Not quite.',
      continueText: 'Nailed it!!'
    }
  ],
  efficient_effective: [
    {
      question: '',
      subtitle: '',
      image: '//d2bsj3sc0hks5v.cloudfront.net/icare/images/module6/IconsArtboard+24-100.jpg',
      answers: [
        {index: 0, answer: '"Good morning"'},
        {index: 1, answer: '"NEXT!"'},
        {index: 2, answer: '"How are you?"'},
        {index: 3, answer: '"Where are you flying to?"'},
        {index: 4, answer: '"I.D"'},
        {index: 5, answer: '"How\'s your day going?'}
      ],
      correct: [
        {index: 0, answer: '"Good morning"'},
        {index: 2, answer: '"How are you?"'},
        {index: 3, answer: '"Where are you flying to?"'},
        {index: 5, answer: '"How\'s your day going?'}
      ],
      wrongText: "You got this.",
      continueText: 'Right on!'
    },
    {
      question: '',
      subtitle: ' ',
      image: '//d2bsj3sc0hks5v.cloudfront.net/icare/images/module6/IconsArtboard+25-100.jpg',
      answers: [
        {index: 0, answer: 'Yes, it slows things down when people smile and are nice.'},
        {index: 1, answer: 'No, you can be efficient and effective while smiling and being nice!'},
      ],
      correct: [
        {index: 1, answer: 'No, you can be efficient and effective while smiling and being nice!'},
      ],
      wrongText: 'I don\'t think so.',
      continueText: 'Right on!'
    }, {
      question: '',
      subtitle: '',
      image: '//d2bsj3sc0hks5v.cloudfront.net/icare/images/module6/IconsArtboard+26-100.jpg',
      answers: [
        {index: 0, answer: 'Smiling as they direct the guests'},
        {index: 1, answer: 'Shouting and sharing the safety rules and regulations'},
        {index: 2, answer: 'Staying focused on their tasks of checking ID while greeting and having fun!'},
        {index: 3, answer: 'Talking to their co-workers'},
        {index: 4, answer: 'Moving the line forward by using positive hand gestures and positive body language.'},
        {index: 5, answer: 'Warm tone of voice, "Have a nice day!"'}
      ],
      correct: [
        {index: 0, answer: 'Smiling as they direct the guests'},
        {index: 2, answer: 'Staying focused on their tasks of checking ID while greeting and having fun!'},
        {index: 4, answer: 'Moving the line forward by using positive hand gestures and positive body language.'},
        {index: 5, answer: 'Warm tone of voice, "Have a nice day!"'}
      ],
      wrongText: 'Nice try.',
      continueText: 'Awesome, you rock!'
    }
  ],
  ending: [
    {
      question: '',
      subtitle: '',
      image: '//d2bsj3sc0hks5v.cloudfront.net/icare/images/module7/IconsArtboard+27-100.jpg',
      answers: [
        {index: 0, answer: 'Being approachable and helping others creates memorable moments.'},
        {index: 1, answer: 'My boss told me to care.'},
        {index: 2, answer: 'Helps you feel good about yourself.'},
      ],
      correct: [
        {index: 0, answer: 'Being approachable and helping others creates memorable moments.'},
        {index: 2, answer: 'Helps you feel good about yourself.'},
      ],
      wrongText: "No, but good try.",
      continueText: 'You\'re LAXceptional!'
    }
  ],
}


// WEBPACK FOOTER //
// ./src/microActivityData.js